import {
  IoIosArrowDroprightCircle,
  IoIosCheckbox,
  IoMdBuild,
  IoMdCash,
  IoMdStats,
  IoMdTimer,
} from "react-icons/io";
import { Link } from "react-router-dom";
import {
  ABOUT_US,
  COMPETENT_AND_TRAINED_CREW,
  CONTINUOUS_MONITORING,
  COST_EFFECTIVE_OPERATIONS,
  LONG_TEXT_ABOUT_US_1,
  LONG_TEXT_ABOUT_US_2,
  LONG_TEXT_ABOUT_US_3,
  REGULAR_AUDITS_AND_INSPECTIONS,
  RESPONSIVE_AND_PROFESSIONAL_SERVICE,
} from "../../constants/translations";
import scrollToTop from "../../hybrids/functions/scrollToTop";
import { ABOUT_US_ROUTE } from "../../routes/routes";
const FullAboutUs = () => {
  return (
    <section className="full-about-us-section">
      <div className="tabs-content-wrapper">
        <div className="tab-item">
          <span className="tab-icon">
            <IoMdStats />
          </span>
          <p className="tab-text">{CONTINUOUS_MONITORING}</p>
        </div>
        <div className="tab-item">
          <span className="tab-icon">
            <IoMdBuild />
          </span>
          <p className="tab-text">{REGULAR_AUDITS_AND_INSPECTIONS}</p>
        </div>
        <div className="tab-item">
          <span className="tab-icon">
            <IoMdTimer />
          </span>
          <p className="tab-text">{COMPETENT_AND_TRAINED_CREW}</p>
        </div>
        <div className="tab-item">
          <span className="tab-icon">
            <IoIosCheckbox />
          </span>
          <p className="tab-text">{RESPONSIVE_AND_PROFESSIONAL_SERVICE}</p>
        </div>
        <div className="tab-item no-border">
          <span className="tab-icon">
            <IoMdCash />
          </span>
          <p className="tab-text">{COST_EFFECTIVE_OPERATIONS}</p>
        </div>
      </div>
      <div className="long-text-about-us">
        <div className="long-content-wrapper">
          <p className="long-text">{LONG_TEXT_ABOUT_US_1}</p>
          <p className="long-text">{LONG_TEXT_ABOUT_US_2}</p>
          <p className="long-text">{LONG_TEXT_ABOUT_US_3}</p>
          <Link
            to={ABOUT_US_ROUTE}
            onClick={scrollToTop}
            className="main-btn about-us-btn"
          >
            {ABOUT_US}
            <IoIosArrowDroprightCircle />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FullAboutUs;
